<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/customer/renewal/push/log/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('kehubianma')">
            <el-input v-model="yt.conditions.customerCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehumingcheng')">
            <el-input v-model="yt.conditions.customerName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'admin_customer_info_push_log_list',
  data() {
    return {
      columns: [
        {
          label: 'kehubianma',
          prop: 'customer.code',
          width: 150
        },
        {
          label: 'kehumingcheng',
          prop: 'customer.name',
          width: 150
        },
        {
          label: 'tuisongshijian',
          prop: 'time',
          type: 'time',
          width: 180
        },
        {
          label: 'tuisongzhuangtai',
          prop: 'status',
          type: 'tag',
          tags: {
            "1": {
              color: '#67c23a',
              text: this.$t('chenggong')
            },
            "0": {
              color: '#f56c6c',
              text: this.$t('shibai')
            }
          }
        },
        {
          label: 'jiekouxiaoxi',
          prop: 'message'
        },
        {
          label: 'tuisongfangshi',
          prop: 'method',
          type: 'dictionary',
          key: 'CUSTOMER_PUSH_METHOD'
        },
        {
          label: 'tuisongdizhi',
          prop: 'address'
        },
        {
          label: 'xiaoxineirong',
          prop: 'content'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {}
};
</script>
